import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import { AdminModalProvider } from "./components/AdminModalProvider";
import AdminSessionCleanup from "./components/AdminSessionCleanup";

export default function AdminLayout() {
  return (
    <AdminModalProvider>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link rel="stylesheet" href={assetUrl("./styles/admin-base.css")} />
        <link rel="stylesheet" href={assetUrl("./styles/sonner.css")} />
      </Helmet>
      <Toaster
        position="top-center"
        theme="light"
        closeButton={false}
        visibleToasts={3}
        gap={10}
        duration={3200}
        toastOptions={{
          closeButton: false,
          classNames: {
            toast: "admin-sonner-toast",
            title: "admin-sonner-title",
            description: "admin-sonner-description",
            closeButton: "admin-sonner-close",
          },
        }}
      />
      <div className="admin-root">
        <AdminSessionCleanup />
        <Outlet />
      </div>
    </AdminModalProvider>
  );
}
